<template>
  <div class="gradient-row">
    <div class="QA">
      <h4>常见问题</h4>
      <h5>Q&A</h5>
      <div class="QAlist-row">
        <div v-for="(el, ind) in QAlist" :key="ind">
          <div class="QAtitle">{{ el.title }}</div>
          <div class="QAcontent" v-html="el.content"></div>
          <el-divider></el-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      QAlist: [
        {
          title: "为什么我的版本不是最新的，我该如何更新最新版？",
          content:
            "一般的，新版本都会同步提交各个商店，由于不同软件商店的审核周期不同，可能导致版本落后，耐心等待审核通过即可。或者通过本站下载crx文件的方式手动安装。",
        },
        {
          title: "我使用的浏览器为国产浏览器，怎样安装插件？",
          content:
            "对于使用Chromium内核的国产浏览器，强烈建议你利用科学上网方法访问Chrome商店来获取自选基金助手，这样可以保持插件自动更新最新版，或者通过本站下载crx文件的方式手动安装，其他途径获取的插件不能保证其安全性。",
        },
        {
          title: "手机上可以使用本插件吗？",
          content:
            "微信小程序‘韭菜计算助手’已上线，欢迎使用。本插件主要面向PC端浏览器,手机端兼容性问题未详细测试，Android手机可以通过火狐Firefox浏览器或Kiwi浏览器使用，火狐Firefox浏览器可以直接在附加组件商店中安装使用，Kiwi浏览器可以通过Chrome商店或者导入crx文件的方式安装。iOS系统暂时无法安装。",
        },
        {
          title: "为什么某些基金估算涨跌幅与估值收益不符？",
          content: "在基金分红的第二天，估算收益为基金当日涨跌幅收益减去分红后的收益。查看基金分红可以通过点击基金名称，查看基金概况标签下的基金分红状态。",
        },
        {
          title: "为什么插件上显示的收益与我在支付宝等平台上显示的不一样？",
          content:
            "请先确认持有份额与成本价是否填写正确（部分基金会不定期调整基金的单位净值或者产生分红，导致持有份额被动更改）。其次，在交易时间内的收益为估值收益，不同平台计算的估值会有差异（本插件数据源来自天天基金网），晚上更新实际净值后的估值为当日实际收益。",
        },
        {
          title: "本插件是免费软件吗？",
          content:
            "自选基金助手不是一个商业软件，尽管本插件目前可以免费使用，但它更依赖您的打赏支持才能得以持续更新。",
        },
        {
          title: "插件使用中遇到问题想联系作者怎么办？",
          content:
            "请先确保插件为最新版，你可以发邮件至：<a href='mailto:lbxuan123@gmail.com'>lbxuan123@gmail.com</a> 或者在 <a href='https://github.com/x2rr/funds'>Github</a> 提交 <a href='https://github.com/x2rr/funds/issues'>issue</a>，除非确有必要，你的邮件很有可能不会被回复。",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.QA {
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  h4 {
    font-size: 30px;
    margin: 40px 0 20px;
  }
  h5 {
    font-size: 24px;
    margin: 10px 0 30px;
  }

  .QAlist-row {
    max-width: 800px;
    padding: 30px 0;
    margin: 0 auto;
    text-align: left;
    .QAtitle {
      font-size: 22px;
      font-weight: bold;
      line-height: 1.5;
      padding-bottom: 10px;
    }
    .QAcontent {
      font-size: 18px;
      line-height: 1.8;
      text-align: justify;
      color: #777;
      font-weight: normal;
    }
    .el-divider {
      background-color: rgba($color: #7a7a7a, $alpha: 0.2);
    }
    .el-divider--horizontal {
      margin: 22px 0;
    }
  }
}
</style>
